import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PatchCatalogProductBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Updates an existing catalog product, then invalidates the catalog list cache. */
export function useUpdateCatalogProduct() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...body }: PatchCatalogProductBody & { id: string }) => {
      const response = await api.patch('/products/catalog/:id', { params: { id }, body })
      if (!response.success) throw new Error(response.error.message)
      return response.data.product
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['catalog-products'] })
    },
  })
}
